import { useState } from 'react';
import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  const [activeTab, setActiveTab] = useState('all');

  const tabs = [
    { key: 'all', label: '全部' },
    { key: 'hot', label: '最热' },
    { key: 'new', label: '最新' },
  ];

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-8 md:mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500">全网最热话题标签，点击查看相关爆料</p>
          </div>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${activeTab === tab.key ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-500 text-sm" />
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}